import { useAuthStore } from '@/store-pinia/auth'

type AuthStrategy = 'local' | 'anonymous'

const authLoginEndpoints: Record<AuthStrategy, string> = {
  local: '/login',
  anonymous: '/login/anonymous',
}

const mockedAuthStorage = new Proxy<any>(
  {},
  {
    get(_target, prop) {
      const authStore = useAuthStore()
      switch (prop) {
        case 'getUniversal':
          return (key: string) => {
            return authStore.getUniversal(key)
          }
        case 'setUniversal':
          return (key: string, value: any) => {
            return authStore.setUniversal(key, value)
          }
        case 'removeUniversal':
          return (key: string) => {
            return authStore.removeUniversal(key)
          }
        case 'syncUniversal':
          return (key: string, defaultValue: any) => {
            return authStore.syncUniversal(key, defaultValue)
          }
        default:
          return prop
      }
    },
  }
)

const mockedAuth = new Proxy<any>(
  {},
  {
    get(_target, prop) {
      switch (prop) {
        case 'user':
          return mockedAuthStorage.getUniversal('user')
        case 'setUser':
          return (user: any) => {
            mockedAuthStorage.setUniversal('user', user)
          }
        case '$storage':
          return mockedAuthStorage
        case 'loginWith': {
          return (strategy: AuthStrategy, data: unknown) => {
            const endpoint = authLoginEndpoints[strategy]
            const apiClient = useApiClient()
            return apiClient(endpoint, { method: 'POST', body: data })
          }
        }
      }
      return prop
    },
  }
)

const mockedCookies = new Proxy<any>(
  {},
  {
    get(_target, prop) {
      switch (prop) {
        case 'set':
          return (key: string, value: any | null = null, options: any = {}) => {
            const cookie = useCookie(key, { ...options })
            cookie.value = value
          }
        case 'get':
          return (key: string) => useCookie(key).value
        case 'remove':
          return (key: string, options: any = {}) => {
            const cookie = useCookie(key, { ...options })
            cookie.value = null
          }
        default:
          return prop
      }
    },
  }
)

export default defineNuxtPlugin(() => {
  return {
    provide: {
      auth: mockedAuth,
      cookiz: mockedCookies,
    },
  }
})
